import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Notification, NotificationLink, NotificationType } from '../../models/gung-notification/gung-notification';

@Injectable({
  providedIn: 'root'
})
export class GungNotificationService {
  private notificationSubject: BehaviorSubject<Notification> = new BehaviorSubject<Notification>(null);

  /**
 * Function to create a global notification
 * @param title Title of the notification
 * @param message Main message of the notification
 * @param type Can be of type 'success' | 'warning' | 'error' | string
 * @param link Notification link for navigation
 * @param notificationTime Time the notification to remain showing, 1000 equals to 1 second
 * @param customClass Pass custom classes to style the notification
 * @returns Void
 */
  public notify(title: string, message: string, type: NotificationType, link?: NotificationLink, notificationTime?: number, customClass?: string): void {
    this.notificationSubject.next({ title, message, type, link, notificationTime, customClass });
  }

  public getNotificationSubject(): Observable<Notification> {
    return this.notificationSubject;
  }
}
